import { mapState } from 'vuex';

const computed = {
  ...mapState({
    devFlagStore: 'devFlags',
  }),
  devFlagSlugs() {
    return this.devFlagStore.devFlagSlugs;
  },
  devFlags() {
    return this.devFlagStore.flags;
  },
};

export default {
  computed,
};
